<div class="main-content" *ngIf="glaccounts">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							Journal Entry
						</h4>
						<p class="card-category text-right">
							<span *ngIf="reversalJournalNumber">Reversal of Journal #{{ reversalJournalNumber }} — </span>GL Journal Entry
						</p>
					</div>
					<div class="card-body">
						<div class="row">
							<!-- Left Panel: Form -->
							<div class="col-md-4">
								<form [formGroup]="accountForm" class="journal-form" (ngSubmit)="addValue()">
									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Journal Type</mat-label>
										<mat-select formControlName="type">
											<mat-option *ngFor="let type of journal_types" [value]="type">{{ type | uppercase }}</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Transaction Date</mat-label>
										<input matInput [matDatepicker]="picker" formControlName="trandate">
										<mat-datepicker-toggle matSuffix [for]="picker">
											<mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker #picker></mat-datepicker>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Department{{ isDepartmentRequired() ? ' *' : '' }}</mat-label>
										<mat-select formControlName="department">
											<mat-option [value]="null">— None —</mat-option>
											<mat-option *ngFor="let tag of tags" [value]="tag">{{ tag.description }}</mat-option>
										</mat-select>
										<mat-error *ngIf="accountForm.get('department')?.hasError('required')">Department is required for expense GL accounts</mat-error>
									</mat-form-field>

									<app-gl-account-lookup (glselected)="addGl($event)" [reset]="resetjournal" [preselected]="preselectedAccount"></app-gl-account-lookup>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Description</mat-label>
										<input matInput formControlName="description" placeholder="Enter description" appSelectOnFocus>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Entry Type</mat-label>
										<mat-select formControlName="entryType">
											<mat-option value="debit">Debit</mat-option>
											<mat-option value="credit">Credit</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Amount</mat-label>
										<input matInput formControlName="debitcredit" type="number" step="0.01" min="0" placeholder="Enter amount">
									</mat-form-field>

									<div class="text-left d-flex gap-2">
										<button mat-raised-button color="accent" class="full-width" type="submit">{{ editingIndex !== null ? 'Update' : 'Add' }}</button>
										<button *ngIf="editingIndex !== null" mat-raised-button type="button" (click)="cancelEdit()">Cancel</button>
									</div>
								</form>
							</div>

							<!-- Right Panel: Summary -->
							<div class="col-md-8">
								<ng-container *ngIf="debits_credits.length">
									<div class="summary-header">
										<h4>Journal Summary</h4>
										<div class="action-buttons">
											<button mat-icon-button color="primary" (click)="exportXls()">
												<i class="fa fa-file-excel-o"></i>
											</button>
											<button mat-icon-button color="warn" (click)="exportPdf()">
												<i class="fa fa-file-pdf-o"></i>
											</button>
										</div>
									</div>

									<h5 *ngIf="!isBalanced()" class="alert alert-danger text-center">
										Required to Balance: {{ requiredToBalance() | currency }}
									</h5>
									<h5 *ngIf="isBalanced()" class="alert alert-success text-center">
										In Balance: {{ requiredToBalance() | currency }}
									</h5>

									<div class="table-responsive" #print_table>
										<table class="table table-striped">
											<thead>
												<tr>
													<th>Account</th>
													<th>Description</th>
													<th>Department</th>
													<th class="text-center">Type</th>
													<th class="text-right">Debit</th>
													<th class="text-right">Credit</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let d of debits_credits; let i = index" [class.table-warning]="editingIndex === i">
													<td>{{ d.account.accountcode }} - {{ d.account.accountname }}</td>
													<td>{{ d.description }}</td>
													<td>{{ d.department?.description ?? '—' }}</td>
													<td class="text-center">
														<span class="badge" [ngClass]="d.debitcredit >= 0 ? 'badge-success' : 'badge-info'">
															{{ d.debitcredit >= 0 ? 'DEBIT' : 'CREDIT' }}
														</span>
													</td>
													<td class="text-right">
														<span *ngIf="d.debitcredit >= 0">{{ d.debitcredit | currency }}</span>
													</td>
													<td class="text-right">
														<span *ngIf="d.debitcredit < 0">{{ (d.debitcredit * -1) | currency }}</span>
													</td>
													<td>
														<button mat-icon-button color="primary" (click)="editLine(d, i)" [disabled]="editingIndex !== null && editingIndex !== i" matTooltip="Edit line">
															<mat-icon>edit</mat-icon>
														</button>
														<button mat-icon-button color="warn" (click)="removeDC(d)">
															<mat-icon>delete</mat-icon>
														</button>
													</td>
												</tr>
												<tr>
													<td><b>Total</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td class="text-right"><b>{{ getDebitTotal() | currency }}</b></td>
													<td class="text-right"><b>{{ getCreditTotal() | currency }}</b></td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</div>

									<div class="text-right mt-3">
										<button mat-raised-button color="primary" [disabled]="!isBalanced()" (click)="postJournal()">
											Post Journal
										</button>
									</div>
								</ng-container>

								<ng-container *ngIf="!debits_credits.length">
									<div class="empty-state">
										<mat-icon>note_add</mat-icon>
										<h5>Start Adding Entries</h5>
										<p>Values will display here as you enter them.</p>
									</div>
								</ng-container>

								<div class="row mt-3 align-items-end">
									<div class="col-md-12">
										<h5 class="mb-2">Attachments</h5>
										<ngx-dropzone (change)="onAttachmentSelect($event)" class="dropzone-attachments">
											<ngx-dropzone-label>Drop or click (PDF, images, Word, Excel)</ngx-dropzone-label>
											<ngx-dropzone-preview *ngFor="let f of attachmentFiles" [removable]="true" (removed)="onAttachmentRemove(f)">
												<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
											</ngx-dropzone-preview>
										</ngx-dropzone>
									</div>
								</div>

								<mat-expansion-panel class="gl-batch-panel mt-4" [(expanded)]="glUploadPanelExpanded">
									<mat-expansion-panel-header>
										<mat-panel-title><mat-icon class="mr-1">cloud_upload</mat-icon> Upload Batch</mat-panel-title>
										<mat-panel-description>Drop a CSV or Excel file to import journal lines</mat-panel-description>
									</mat-expansion-panel-header>

									<div class="gl-batch-body">

										<!-- Drop zone (shown when no file loaded) -->
										<ng-container *ngIf="!glUploadReady">
											<div class="gl-dropzone"
												[class.gl-dropzone--active]="glDropzoneActive"
												(dragover)="onGlDropzoneDragOver($event)"
												(dragleave)="onGlDropzoneDragLeave($event)"
												(drop)="onGlDropzoneDrop($event)"
												(click)="glFileInput.click()">
												<input type="file" #glFileInput class="d-none" accept=".csv,.xlsx,.xls" (change)="onGlUploadChange($event)">
												<mat-icon class="gl-dropzone__icon">upload_file</mat-icon>
												<p class="gl-dropzone__primary">Drop your file here, or <span class="gl-dropzone__link">browse</span></p>
												<p class="gl-dropzone__hint">Supports .csv, .xlsx, .xls — first row must be headers</p>
											</div>
											<div class="gl-batch-format mt-3">
												<div class="gl-batch-format__chips">
													<span class="gl-chip gl-chip--required">account <span class="gl-chip__note">GL code</span></span>
													<span class="gl-chip gl-chip--required">debitcredit <span class="gl-chip__note">+ debit / − credit</span></span>
													<span class="gl-chip gl-chip--required">department <span class="gl-chip__note">required for expense accounts (6/7xxx); tag name or ID</span></span>
													<span class="gl-chip gl-chip--optional">trandate <span class="gl-chip__note">optional</span></span>
													<span class="gl-chip gl-chip--optional">description <span class="gl-chip__note">optional</span></span>
												</div>
												<button mat-stroked-button class="mt-2" (click)="downloadGlUploadTemplate()">
													<mat-icon>file_download</mat-icon> Download template
												</button>
											</div>
										</ng-container>

										<!-- Mapping + preview (shown after file is loaded) -->
										<ng-container *ngIf="glUploadReady && glUploadedRawData.length">
											<div class="gl-batch-file-bar">
												<mat-icon>insert_drive_file</mat-icon>
												<span class="gl-batch-file-bar__name">{{ glUploadFiles[0]?.name }}</span>
												<span class="gl-batch-file-bar__count">{{ glUploadedRawData.length }} row(s)</span>
												<button mat-icon-button class="ml-auto" (click)="clearGlUpload()" matTooltip="Remove file">
													<mat-icon>close</mat-icon>
												</button>
											</div>

											<p class="gl-batch-map-hint mt-2 mb-1">Map each column to a field, or leave as <em>ignore</em>. If the file has expense accounts (6xxx/7xxx), map a column to <strong>department</strong>.</p>

											<div class="table-responsive gl-batch-table-wrap">
												<table class="table table-sm table-bordered gl-batch-table">
													<thead>
														<tr class="gl-batch-table__map-row">
															<th *ngFor="let h of glUploadedHeaders" class="gl-batch-table__map-cell">
																<mat-form-field appearance="outline" class="gl-batch-select">
																	<mat-select [(value)]="glColumnMappings[h]" (selectionChange)="glColumnMappings[h] = $event.value">
																		<mat-option *ngFor="let type of glAvailableFieldTypes" [value]="type">{{ type }}</mat-option>
																	</mat-select>
																</mat-form-field>
																<div class="gl-batch-table__col-name">{{ h }}</div>
															</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let row of glUploadedRawData; let i = index" [class.gl-batch-table__preview-row]="i < 5">
															<td *ngFor="let h of glUploadedHeaders" class="gl-batch-table__data-cell">
																<input class="gl-batch-edit-input" [(ngModel)]="row[h]" type="text" [attr.aria-label]="'Edit ' + h" />
															</td>
														</tr>
													</tbody>
												</table>
											</div>

											<!-- Balance indicator -->
											<div class="gl-batch-balance mt-3" *ngIf="hasRequiredGlMappings()">
												<div class="gl-batch-balance__bar" [class.gl-batch-balance__bar--ok]="isUploadBatchBalanced()" [class.gl-batch-balance__bar--off]="!isUploadBatchBalanced()">
													<mat-icon>{{ isUploadBatchBalanced() ? 'check_circle' : 'error_outline' }}</mat-icon>
													<span *ngIf="isUploadBatchBalanced()">In balance — ready to post</span>
													<span *ngIf="!isUploadBatchBalanced()">Out of balance by {{ requiredToBalanceUpload() | currency }} — debits must equal credits</span>
												</div>
											</div>

											<div class="gl-batch-actions mt-3">
												<button mat-raised-button color="primary"
													(click)="postGlBatch()"
													[disabled]="!hasRequiredGlMappings() || !isUploadBatchBalanced() || glPosting"
													class="gl-batch-post-btn">
													<mat-icon *ngIf="!glPosting">send</mat-icon>
													<svg *ngIf="glPosting" class="gl-post-spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
														<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
													</svg>
													{{ glPosting ? 'Posting…' : 'Post Batch' }}
												</button>
												<span class="gl-batch-error ml-3" *ngIf="glError">
													<mat-icon>warning</mat-icon> {{ glError }}
												</span>
											</div>
										</ng-container>

									</div>
								</mat-expansion-panel>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>